module.exports = __webpack_public_path__ + "Assets/c13b5491-0ad0-401e-8b39-03a88965ce5a.eot";